import React from 'react';
import { IoAlertCircle } from 'react-icons/io5';

interface Props {
  missingCount: number;
  onClick?: () => void;
  className?: string;
}

const MissingDataIndicator: React.FC<Props> = ({ missingCount, onClick, className }) => {
  if (!missingCount || missingCount <= 0) return null;

  return (
    <button
      onClick={onClick}
      className={["missing-data-indicator", className || ""].join(' ')}
      title={`${missingCount} missing field${missingCount > 1 ? 's' : ''}`}
      aria-label={`Missing ${missingCount} fields`}
    >
      <IoAlertCircle className="missing-data-icon" />
      <span className="missing-data-count">{missingCount}</span>
    </button>
  );
};

export default MissingDataIndicator;
